import Vuetify from "vuetify";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GENERAL_RULES_CONSTANTS,
  DATA_TYPES,
  LABEL_DOCUMENT_TYPES,
  DOCUMENT_TYPE_DEFAULT
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { ListService } from "../../../../List/services/ListService";
import { Http } from "@status/codes";
import { ActionPlanService } from "../../../../ActionPlan/services/ActionPlanService";
import { ActionPlanStatus } from "@/modules/ActionPlan/models/ActionPlanStatus.model";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { ItemReference } from "../../../models/ItemReference.model";
import { CategoryDocument } from "../../../models/CategoryDocument.model";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { AxiosError } from "axios";
import { ACTION_PLAN_ACCESS } from "@/modules/ActionPlan/constants/ActionPlanConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";

Vue.use(Vuetify);
@Component({
  name: "GenerateDocument",
  components: {
    DynamicSelect
  }
})
export default class GenerateDocument extends Vue {
  @Inject() listService!: ListService;
  @Inject() actionPlanService!: ActionPlanService;
  @Prop({ default: false }) private dialog!: boolean;
  @Prop({ default: false }) private edit!: boolean;
  @Prop() private actionPlantToEdit!: ActionPlanStatus;

  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  secondaryCardClass = STYLE_CLASSES.CARD_2;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  TITLE = GENERAL_RULES_CONSTANTS.GENERATE_DOCUMENT;
  CANCEL = GENERAL_RULES_CONSTANTS.TOOLTIP.CANCEL;
  GUARDAR = GENERAL_RULES_CONSTANTS.TOOLTIP.SAVE;
  GO_TO_START = GENERAL_RULES_CONSTANTS.TOOLTIP.GO_TO_START;
  ADD_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.ADD_CONDITION;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;

  documentFieldsValidation = false;
  documentType = "";
  categoryType = "";
  isDisabledCategoryType = true;

  actualDocs: ActionPlanStatus[] = [];
  categoryItems: string[] = [];
  categoryDocuments: CategoryDocument[] = [];
  document = {} as ItemReference;
  keyCounter = 1;
  documentTypeModel = [{ id: "", name: "" }];
  categoryItemModel = [{ id: "", name: "" }];
  documentCategoryItemModel = [
    {
      id: "",
      name: "",
      info: {
        value: "",
        _key: "",
        category: "",
        state: ""
      }
    }
  ];
  documentTypeSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: LABEL_DOCUMENT_TYPES.DOCUMENT_TYPE,
    hideDetails: false,
    required: true
  };

  categorySelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: LABEL_DOCUMENT_TYPES.CATEGORY_LABEL,
    hideDetails: false,
    required: true
  };

  documentCategorySelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: LABEL_DOCUMENT_TYPES.DOCUMENT_CATEGORY_LABEL,
    hideDetails: false,
    required: true
  };
  editComparationStr = "";
  invalidEdit = false;
  loadingEdit = false;

  async mounted() {
    await this.getCategoryList();
    this.documentTypeSelectConfig.listAll = [DOCUMENT_TYPE_DEFAULT];
  }

  get selectDocumentTypeFormField() {
    return this.documentTypeModel[0].id;
  }

  set selectDocumentTypeFormField(value: string) {
    const option = this.documentTypeSelectConfig.listAll.find(
      item => item.id === value
    );
    this.documentTypeModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get selectCategoryTypeField() {
    return this.categoryItemModel[0].id;
  }

  set selectCategoryTypeField(value: string) {
    const option = this.categorySelectConfig.listAll.find(
      item => item.id === value
    );
    this.categoryItemModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get selectDocumentCategoryField(): any {
    return this.documentCategoryItemModel[0].info;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set selectDocumentCategoryField(value: any) {
    const option = this.documentCategorySelectConfig.listAll.find(
      item => item.id === value
    );
    this.documentCategoryItemModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? "",
        info: {
          value: option?.info?.value ?? "",
          _key: option?.info?._key ?? "",
          category: option?.info?.category ?? "",
          state:
            typeof option?.info?.state === DATA_TYPES.STRING
              ? typeof option?.info?.state
              : ""
        }
      }
    ];
  }
  @Watch("document", { deep: true })
  checkEdit() {
    if (this.edit && !this.loadingEdit && this.editComparationStr != "") {
      this.invalidEdit =
        JSON.stringify(this.document) === this.editComparationStr;
    }
    if (this.edit && !this.loadingEdit && this.editComparationStr == "") {
      this.editComparationStr = JSON.stringify(this.document);
      this.invalidEdit = true;
    }
  }
  @Watch("categoryItemModel")
  updateCategoryItemModel() {
    this.categoryType = this.selectCategoryTypeField;
    this.enableDocumentSelection();
  }
  @Watch("documentCategoryItemModel")
  updateDocumentCategoryItemModel() {
    this.document = this.selectDocumentCategoryField;
  }

  @Watch("documentTypeModel")
  async updateDocumentType() {
    this.documentType = this.selectDocumentTypeFormField;
  }

  async getCategoryList() {
    try {
      const response = await this.listService.getListDataByName(
        GENERAL_RULES_CONSTANTS.ACTION_PLAN_CATEGORY
      );

      if (response.code === Http.Found) {
        const { data } = response;
        this.categoryItems =
          data?.optionsSchema.map(option => option.title) ?? [];
        this.categorySelectConfig.listAll = data!.optionsSchema.map(item => {
          return {
            id: item.title,
            name: item.title
          };
        });
      } else if (response.code === Http.NotFound) {
        Snackbar.popWarning(
          GENERAL_RULES_CONSTANTS.MESSAGES.NOT_FOUND_CATEGORY +
            GENERAL_RULES_CONSTANTS.ACTION_PLAN_CATEGORY
        );
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_FAILED);
    }
  }

  async getDocumentByCategory(category: string) {
    let categoryDocuments: CategoryDocument[] = [];
    try {
      const response = await this.actionPlanService.getActionPlanByQuery({
        category: [category]
      });

      if (response.code === Http.Found) {
        const { data } = response;
        this.actualDocs = [...(data?.actionPlanList ?? [])];
        categoryDocuments =
          data?.actionPlanList.map(plan => {
            return {
              name: plan.name,
              info: {
                value: plan.name ?? "",
                _key: plan._key ?? "",
                category: plan.category,
                state: plan.state
              }
            };
          }) ?? [];
      } else if (response.code === Http.NotFound) {
        Snackbar.popWarning(
          GENERAL_RULES_CONSTANTS.MESSAGES.NOT_FOUND_ACTION_PLAN + category
        );
      }
      this.invalidEdit = true;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.GET
        );
      else Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_FAILED);
    }
    this.categoryDocuments = categoryDocuments;
    this.documentCategorySelectConfig.listAll = this.categoryDocuments.map(
      item => {
        return {
          id: item.name,
          name: item.name,
          info: item.info
        };
      }
    );
    if (this.categoryDocuments.length > 0) {
      this.isDisabledCategoryType = false;
    }
  }

  cleanModalEntries() {
    this.documentType = "";
    this.categoryType = "";
    this.document = {} as ItemReference;
    this.documentTypeModel = [{ id: "", name: "" }];
    this.categoryItemModel = [{ id: "", name: "" }];
    this.documentCategoryItemModel = [
      {
        id: "",
        name: "",
        info: {
          value: "",
          _key: "",
          category: "",
          state: ""
        }
      }
    ];
  }

  closeModal() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_MODAL_GENERATE_DOCUMENT);
    if (!this.edit) {
      this.cleanModalEntries();
      this.keyCounter = 1 - this.keyCounter;
    }
  }

  acceptModal() {
    const actionPlan = {
      category: this.document.category,
      state: this.document.state,
      name: this.document.value,
      _key: this.document._key
    };

    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.ACCEPT_MODAL_GENERATE_DOCUMENT,
      actionPlan
    );
  }

  async enableDocumentSelection() {
    if (this.categoryType) {
      await this.getDocumentByCategory(this.categoryType);
    }
    this.isDisabledCategoryType = !this.categoryType;
  }

  @Watch("dialog")
  async validateAndCleanOpenModal() {
    if (this.dialog && !this.edit) {
      this.cleanModalEntries();
      this.keyCounter = 1 - this.keyCounter;
    }

    if (this.dialog && this.edit) {
      this.invalidEdit = true;
      this.loadingEdit = true;
      this.documentType = GENERAL_RULES_CONSTANTS.ACTION_PLAN;
      this.selectDocumentTypeFormField = this.documentType;
      this.categoryType = this.actionPlantToEdit.category;
      this.selectCategoryTypeField = this.categoryType;
      await this.getDocumentByCategory(this.categoryType);
      this.document = {
        value: this.actionPlantToEdit.name,
        _key: this.actionPlantToEdit._key ?? "",
        category: this.actionPlantToEdit.category ?? "",
        state: this.actionPlantToEdit.state
      };
      this.selectDocumentCategoryField = this.document.value;
      this.loadingEdit = false;
    }
  }
}
